import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  container: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    margin: '24px 20px',
    maxWidth: '1080px',
    [Theme.breakpoints.up('sm')]: {
      margin: '24px 30px',
    },

    [Theme.breakpoints.up('md')]: {
      margin: '24px 50px',
    },
    [Theme.breakpoints.up('1100')]: {
      margin: '24px auto 0',
      paddingLeft: '50px',
    },
    [Theme.breakpoints.up('xl')]: {
      paddingLeft: '0',
    },
  },
  flightsCancellationTitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.pxToRem(24),
    lineHeight: '150%',
    color: Theme.palette.primary.main,
    marginBottom: '8px',

    [Theme.breakpoints.up('lg')]: {
      fontSize: Theme.typography.pxToRem(30),
    },
    [Theme.breakpoints.up('xl')]: {
      fontSize: Theme.typography.pxToRem(36),
    },
  },

  flightsCancellationDescription: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.pxToRem(16),
    lineHeight: '150%',
    color: Theme.palette.gray[750],
    marginBottom: '20px',

    [Theme.breakpoints.up('lg')]: {
      fontSize: Theme.typography.pxToRem(18),
    },
  },

  contentContainer: {
    boxShadow: '0px 2px 4px rgba(6, 21, 86, 0.15)',
    borderRadius: '5px',
    padding: '30px 20px 0px',
    height: 'calc(100% + 32px)',
    background: Theme.palette.white,
    borderBottomRightRadius: '0',

    [Theme.breakpoints.up('sm')]: {
      padding: '40px 30px 15px',
    },

    [Theme.breakpoints.up('xl')]: {
      padding: 40,
      paddingBottom: 15,
    },

    '& .MuiAccordionSummary-root': {
      padding: 0,
    },

    '& .confirmation': {
      '& span': {
        color: Theme.palette.gray[750],
        textTransform: 'uppercase',
        fontFamily: Theme.typography.base.regular,
        fontSize: Theme.typography.pxToRem(16),
      },

      '& h6': {
        display: 'block',
        textTransform: 'lowercase',
      },
      '& h6:first-letter': {
        textTransform: 'uppercase',
      },
      [Theme.breakpoints.up('sm')]: {
        flex: 1,
        '& span': {
          display: 'block',
        },
      },

      [Theme.breakpoints.up('md')]: {
        '& span': {
          display: 'inline-block',
        },
      },
    },

    '& .details': {
      fontSize: Theme.typography.pxToRem(14),
      color: Theme.palette.primary.light,
      fontFamily: Theme.typography.base.regular,
      width: '100%',

      [Theme.breakpoints.up('sm')]: {
        width: 'auto',
        alignSelf: 'flex-end',
      },
    },

    '& p': {
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.primary.main,
    },

    '& .MuiAccordionSummary-content': {
      borderBottom: `1px solid ${Theme.palette.gray[250]}`,
      paddingBottom: '20px',
      marginTop: '0',
      flexDirection: 'column',
    },

    '& .MuiAccordionDetails-root': {
      padding: 0,
      display: 'block',

      '& p': {
        color: Theme.palette.gray[750],
        fontFamily: Theme.typography.base.regular,

        [Theme.breakpoints.up('sm')]: {
          paddingLeft: 20,
        },
      },
    },

    '& .MuiAccordionActions-root': {
      margin: '30px -20px -20px',
      padding: 20,
      background: Theme.palette.gray[100],
      display: 'flex',
      flexDirection: 'column',
      gap: 10,

      '& button:nth-child(2)': {
        color: Theme.palette.primary.light,
      },
      [Theme.breakpoints.up('sm')]: {
        flexDirection: 'row-reverse',
        justifyContent: 'flex-start',
        margin: '30px -30px -15px',
        padding: '20px 30px',

        '& button:first-child': {
          margin: 0,
        },
      },
      [Theme.breakpoints.up('xl')]: {
        margin: '40px -40px -15px',
      },
    },
  },
  headerModal: {
    marginBottom: Theme.spacing(2),
    [Theme.breakpoints.up('md')]: {
      marginBottom: '40px',
    },
  },

  footerModal: {
    display: 'grid',
    justifyContent: 'initial',
    gap: '10px',
    // The labels come from AEM, not from the bundled defaults, and the live copy ("No, go back" /
    // "Yes, cancel flights") is far longer than the fallbacks ("Keep Flights" / "Cancel Flights").
    // Without this the two buttons shrink to fit a 40%-wide modal and their labels wrap.
    '& button': {
      whiteSpace: 'nowrap',
    },
    [Theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      // Wrap the row rather than squeeze the buttons: when both no longer fit side by side they
      // stack, each keeping its label on one line.
      flexWrap: 'wrap',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      '& button:first-child': {
        order: 2,
      },
      '& button:last-child': {
        order: 1,
      },
    },
  },

  buttonModal: {
    marginLeft: 'initial!important',
    color: Theme.palette.primary.light,
  },
  criticalActionbuttonModal: {
    backgroundColor: `${Theme.palette.error.main}!important`,
  },
  customBanner: {
    margin: '-6px 0 24px 0',
    position: 'relative',
    '& div': {
      fontSize: Theme.typography.pxToRem(18),
    },
    '& span': {
      fontSize: Theme.typography.pxToRem(14),
    },
    '& button': {
      position: 'absolute',
      right: 0,
      background: 'none',
      border: 'none',
      margin: '10px',
      color: Theme.palette.white,

      [Theme.breakpoints.up('md')]: {
        color: Theme.palette.primary.light,
      },
    },
    [Theme.breakpoints.up('md')]: {
      margin: '-56px 0 24px 0',
    },
    [Theme.breakpoints.up('xl')]: {
      margin: '-32px 0 48px 0',
    },
  },
  buttonHover: {
    '&:hover': {
      background: 'none',
    },
  },

  notification: {
    marginBottom: '24px',
  },

  backButtonContainer: {
    alignSelf: 'flex-start',
    marginBottom: '30px',
    '& .back-button': {
      color: Theme.palette.primary.light,
      fontSize: Theme.typography.size[2],
      textDecoration: 'underline',
      padding: '0',
      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[3],
      },
      '& svg': {
        marginLeft: '-6px',
      },
      '&:hover': {
        background: 'none',
      },
    },
  },
}));

export default useStyles;
